import { FC, SVGProps } from 'react';
import { Button, ButtonSizes, ButtonStyles, Icon } from '@silverfort/sf-components';

type SmallEmptyStateSectionProps = {
    action?: {
        onClick: () => void;
        label: string;
    };
    description: string;
    icon: FC<SVGProps<SVGSVGElement>>;
    title: string;
};

export const SmallEmptyStateSection: FC<SmallEmptyStateSectionProps> = ({ action, description, icon, title }) => {
    return (
        <div className="flex gap-2 border border-gray-100 rounded-lg px-4 py-5 h-40">
            <Icon className="text-sf-gray-400" icon={icon} size={24} />

            <div className="flex flex-col justify-between grow gap-4">
                <span className="flex flex-col gap-2">
                    <span className="text-13 font-medium text-left">{title}</span>
                    <span className="text-13 text-sf-gray-500 text-left">{description}</span>
                </span>

                {action && (
                    <Button
                        buttonSize={ButtonSizes.Small}
                        buttonStyle={ButtonStyles.Primary}
                        onClick={action.onClick}
                        text={action.label}
                    />
                )}
            </div>
        </div>
    );
};
